const SETTINGS_KEY = 'lithoform-settings';

export interface GameSettings {
  sfxEnabled: boolean;
  musicEnabled: boolean;
}

const defaultSettings: GameSettings = {
  sfxEnabled: false,
  musicEnabled: false,
};

export function getSettings(): GameSettings {
  const raw = localStorage.getItem(SETTINGS_KEY);
  if (!raw) return { ...defaultSettings };

  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return {
      sfxEnabled: typeof parsed.sfxEnabled === 'boolean' ? parsed.sfxEnabled : defaultSettings.sfxEnabled,
      musicEnabled: typeof parsed.musicEnabled === 'boolean' ? parsed.musicEnabled : defaultSettings.musicEnabled,
    };
  } catch {
    return { ...defaultSettings };
  }
}

export function saveSettings(settings: GameSettings): void {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}
